import { Grid } from '@material-ui/core';
import { Skeleton } from '#root/components/ui/primitives/skeleton/Skeleton';
import { GuveryPaper } from '#root/ui-components/cards';
import styles from './shipmentCardSkeleton.module.scss';

interface ShipmentCardSkeletonProps {
  count?: number;
}

const ShipmentCardSkeletonItem = () => (
  <GuveryPaper disableHover>
    <div className={styles.root}>
      <div className={styles.body}>
        {/* Header: ID + Badge */}
        <div className={styles.header}>
          <div className={styles.headerTitle}>
            <Skeleton variant="text" width={60} height={24} />
            <Skeleton variant="rect" width={90} height={24} style={{ marginLeft: 10 }} />
            <Skeleton variant="text" width={200} height={16} style={{ marginLeft: 8 }} />
          </div>
        </div>

        {/* Grid: Fecha + Destino */}
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <div className={styles.infoItem}>
              <Skeleton variant="text" width={80} height={14} />
              <div className={styles.infoContent}>
                <Skeleton variant="rect" width={18} height={18} />
                <Skeleton variant="text" width={120} height={18} style={{ marginLeft: 4 }} />
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <div className={styles.infoItem}>
              <Skeleton variant="text" width={50} height={14} />
              <div className={styles.infoContent}>
                <Skeleton variant="rect" width={18} height={18} />
                <Skeleton variant="text" width={100} height={18} style={{ marginLeft: 4 }} />
              </div>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className={styles.infoItem}>
              <Skeleton variant="text" width={70} height={14} />
              <div className={styles.infoContent}>
                <Skeleton variant="rect" width={18} height={18} />
                <Skeleton variant="text" width="60%" height={18} style={{ marginLeft: 4 }} />
              </div>
            </div>
          </Grid>
        </Grid>
      </div>

      {/* Right: Actions */}
      <div className={styles.right}>
        <div className={styles.actions}>
          <Skeleton variant="rect" width="100%" height={36} />
          <Skeleton variant="rect" width="100%" height={36} />
        </div>
      </div>
    </div>
  </GuveryPaper>
);

const ShipmentCardSkeleton = ({ count = 1 }: ShipmentCardSkeletonProps) => (
  <Grid container spacing={3}>
    {Array.from({ length: count }).map((_, i) => (
      <Grid key={i} item xs={12}>
        <ShipmentCardSkeletonItem />
      </Grid>
    ))}
  </Grid>
);

export default ShipmentCardSkeleton;
